import React from 'react';
import { PropTypes } from 'prop-types';
import NoteCard from './Note';

const NoteCards = ({
  notes, onClick,
}) => {
  return (
    <div className="w-full">
      <div className="grid justify-start grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-6 gap-x-6 gap-y-8">
        {notes.map(note => (
          <NoteCard
            key={note.id}
            siteName={note.site_name}
            date={note.timestamp}
            title={note.title}
            content={note.content}
            status={note.status}
            priority={note.priorityCardColor}
            onClick={() => onClick(note.id)}
          />
        ))}
      </div>
    </div>
  );
};

NoteCards.propTypes = {
  notes: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(NoteCards);
